import { GigPiece } from "../gigPiece";
import { Interactor } from "../interactor";

/**
 * Gig_Entity type guard.
 *
 * @param {any} gigJson Gig object from API
 * @returns {boolean} Return true if type is Gig_Entity
 */
function validator(gigJson: unknown): gigJson is Gig_Entity {
  if (typeof gigJson === "object" && gigJson != null) {
    Gig_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(gigJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Gig_Entity {
  static requiredFields = [
    "id",
    "memberID",
    "sessionTypeID",
    "title",
    "dateFromUTC",
    "dateToUTC",
    "venueID",
    "url",
    "memo",
    "dressCode",
    "wages",
    "paid",
    "paymentDateUTC",
    "contractorID",
    "projectID",
    "stageID",
    "pieces",
    "playing",
    "timezone",
    "publicToken",
    "interactors",
    "sourceID",
    "sourceRecordID",
    "missionID",
    "createdAt",
    "updatedAt",
  ];

  constructor(gigJson: unknown) {
    if (validator(gigJson)) {
      this.id = gigJson.id;
      this.memberID = gigJson.memberID;
      this.sessionTypeID = gigJson.sessionTypeID;
      this.title = gigJson.title;
      this.dateFromUTC = gigJson.dateFromUTC;
      this.dateToUTC = gigJson.dateToUTC;
      this.venueID = gigJson.venueID;
      this.url = gigJson.url;
      this.memo = gigJson.memo;
      this.dressCode = gigJson.dressCode;
      this.wages = gigJson.wages;
      this.paid = gigJson.paid;
      this.paymentDateUTC = gigJson.paymentDateUTC;
      this.contractorID = gigJson.contractorID;
      this.projectID = gigJson.projectID;
      this.stageID = gigJson.stageID;
      this.pieces = gigJson.pieces;
      this.playing = gigJson.playing;
      this.timezone = gigJson.timezone;
      this.publicToken = gigJson.publicToken;
      this.interactors = gigJson.interactors;
      this.sourceID = gigJson.sourceID;
      this.sourceRecordID = gigJson.sourceRecordID;
      this.missionID = gigJson.missionID;
      this.createdAt = gigJson.createdAt;
      this.updatedAt = gigJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Gig_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  memberID: number;
  sessionTypeID: number;
  title: string;
  dateFromUTC: string;
  dateToUTC: string;
  venueID: number;
  url: string;
  memo: string;
  dressCode: string;
  wages: number;
  paid: boolean;
  paymentDateUTC: string;
  contractorID: number;
  projectID: number;
  stageID: number;
  pieces: Array<Partial<GigPiece>>;
  playing: boolean;
  timezone: string;
  publicToken: string;
  interactors: Array<Interactor>;
  sourceID: number;
  sourceRecordID: number;
  missionID: number;
  createdAt: string;
  updatedAt: string;
}
